import React from 'react';
import EditorOrdered from '@wix/da-ds/pkg/Icons/24x24/EditorOrdered';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
const OrderedList = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'orderedList')) {
        return null;
    }
    if (editor.isActive('bulletList')) {
        return /*#__PURE__*/ React.createElement(EditorIconButton, {
            featureId: "format:orderedList",
            icon: EditorOrdered,
            onClick: ()=>{
                editor.chain().focus().toggleList('orderedList', 'listItem', true).run();
            },
            isActive: editor.isActive('orderedList'),
            tooltipText: t('button.ordered.tooltip'),
            "aria-label": t('button.ordered.tooltip')
        });
    }
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "format:orderedList",
        icon: EditorOrdered,
        disabled: !editor.can().chain().focus().toggleOrderedList().run(),
        onClick: ()=>editor.chain().focus().toggleOrderedList().run(),
        isActive: editor.isActive('orderedList'),
        tooltipText: t('button.ordered.tooltip'),
        "aria-label": t('button.ordered.tooltip')
    });
};
OrderedList.displayName = 'OrderedList';
export default OrderedList;

//# sourceMappingURL=OrderedList.js.map